<template>
  <div class="text-input-container">
    <div
      v-if="label"
      class="input-label-container"
    >
      <label
        v-if="label"
        class="input-label"
      > {{ label }} </label>
      <span
        v-if="showRequired"
        class="required-label"
      >(required)</span>
    </div>
    <input
      v-bind="$attrs"
      :value="modelValue"
      class="input-field"
      :aria-label="label"
      :tabindex="disabled ? -1 : 0"
      :class="{disabled: disabled}"
      :aria-required="required || showRequired"
      @input="onChanged"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextInput',
  props: {
    modelValue: {
      type: String,
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onChanged(e: any): void {
      emit('update:modelValue', e.currentTarget.value)
    }

    return {
      onChanged
    }
  }
})
</script>

<style scoped lang="scss">
.text-input-container {
  text-align: left;

  > .input-label-container {

    > .input-label {
      @include input-text-field-label;
    }

    > .required-label {
      @include input-text-field-label;
      margin-left: 5px;
      font-weight: 300;
    }
  }

  > .input-field {
    @include input-text-field;
  }
}
</style>
